class EventTracker {
    constructor() {
        this.allowedTriggers = [
            'click',
            'change',
        ];
    }

    initTracking(elem = document) {
        window.dataLayer = window.dataLayer || [];

        for (const trackingNode of elem.querySelectorAll('[data-tracking-event]')) {
            const trigger = trackingNode.getAttribute('data-tracking-trigger');

            // Only set event listener for allowed triggers (js events)
            if (this.allowedTriggers.indexOf(trigger) !== -1) {
                trackingNode.addEventListener(trigger, this.pushEvent.bind(this));
            }
        }
    }

    getEventAction(e) {
        let eventAction = e.currentTarget.getAttribute('data-tracking-eventaction');
        const trigger = e.currentTarget.getAttribute('data-tracking-trigger');

        if (trigger === 'change') {
            const selectedOption = e.currentTarget.querySelector(':checked');
            eventAction = selectedOption.text.trim();
        }

        return eventAction;
    }

    pushEvent(e) {
        const eventCategory = e.currentTarget.getAttribute('data-tracking-eventcategory');
        const eventLabel = e.currentTarget.getAttribute('data-tracking-eventlabel');
        const event = e.currentTarget.getAttribute('data-tracking-event');
        const stopClass = e.currentTarget.getAttribute('data-tracking-stop-class');
        if (e.currentTarget.classList.contains(stopClass)) {
            return;
        }

        const dataLayerObject = {
            eventCategory,
            eventAction: this.getEventAction(e),
            eventLabel,
            event,
        };

        window.dataLayer.push(dataLayerObject);
    }
}

export default new EventTracker();
